export enum LockablePatientRecordSection {
    overview = "overview",
    insurance = "insurance",
    patientChampions = "patientChampions",
    paymentPrograms = "paymentPrograms"
}